var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceitBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style905"
  }, ".st0{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M6.6 1.342a.039.039 0 0 0-.072-.023 228.822 228.822 0 0 0-1.387 2.149H1.15c-.05 0-.07.064-.025.08C2.78 4.174 5.173 5.115 6.51 5.64c.034.014.09-.018.09-.04z",
    style: {
      fill: "#fff",
      strokeWidth: 1
    },
    id: "path1101"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceitBg);
export default __webpack_public_path__ + "static/media/faceit-bg.0531ef621007eedb63385f8dfd1c0a99.svg";
export { ForwardRef as ReactComponent };